import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  IconButton,
  Typography,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import create from 'zustand';

const useConfirmDialogStore = create((set) => ({
  title: 'Confirmation',
  message: '',
  onSubmit: undefined,
  close: () => set({ onSubmit: undefined }),
}));

export const confirmDialog = (
  onSubmit,
  message = 'Do you really want to delete all the data?',
  title = 'Confirmation',
) => {
  useConfirmDialogStore.setState({
    message,
    onSubmit,
    title,
  });
};

function ConfirmDialog() {
  const {
    title, message, onSubmit, close,
  } = useConfirmDialogStore();
  return (
    <Dialog open={Boolean(onSubmit)} onClose={close} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <Box position="absolute" top={0} right={0}>
        <IconButton onClick={close}>
          <Close />
        </IconButton>
      </Box>
      <DialogContent>
        <Typography>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={close} sx={{ color: 'black' }}>
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={() => {
            if (onSubmit) {
              onSubmit();
            }
            close();
          }}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}
export default ConfirmDialog;
